import * as React from 'react';
import { Modal, Input, Button, message } from 'antd';
import { TrainingProjectSessionModel } from '../../models';

const { TextArea } = Input;

type Props = {
    session?: TrainingProjectSessionModel;
    visible: boolean;
    onClose: () => void;
};

const TrainingProjectSessionNoteModal: React.FC<Props> = ({ session, visible, onClose }) => {
    const [noteText, setNoteText] = React.useState<string>('');
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (visible && session) {
            setNoteText(session.internalNote || '');
        }
    }, [visible, session]);

    const handleSave = async () => {
        if (!session) {
            return;
        }

        setIsLoading(true);
        try {
            const trimmedNote = noteText.trim();
            const resp = await session.updateNote(trimmedNote || null);

            if (resp && resp.isOk()) {
                message.success(trimmedNote ? 'Note saved successfully!' : 'Note cleared successfully!');
                onClose();
            } else {
                message.error('Failed to save note. Please try again.');
            }
        } catch (error) {
            message.error('Failed to save note. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        setNoteText(session?.internalNote || '');
        onClose();
    };

    return (
        <Modal
            title="Session Note"
            visible={visible}
            onCancel={handleCancel}
            width={600}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button
                    key="save"
                    type="primary"
                    loading={isLoading}
                    onClick={handleSave}
                    disabled={noteText.length > 5000}
                >
                    Save
                </Button>
            ]}
        >
            <div style={{ marginBottom: '16px' }}>
                <TextArea
                    value={noteText}
                    onChange={e => setNoteText(e.target.value)}
                    placeholder="Enter session note..."
                    autoSize={{ minRows: 4, maxRows: 12 }}
                    maxLength={5000}
                    showCount={{
                        formatter: ({ count, maxLength }) => `${count}/${maxLength} characters`
                    }}
                />
            </div>
        </Modal>
    );
};

export default TrainingProjectSessionNoteModal;
